import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { useDropTarget } from "source/app/services/Shared/Hooks/useDropTarget";
import { DeleteNodeAsync } from "source/app/services/Workflows/ChangeData/DeleteNodesAsync";
import { IWorkflowNode } from "../../../../../../../../../motw_core/Entity/IWorkflowNode";
import { State } from "source/app/services/UI/State/State";
import { ISearchNodesState } from "../../../SearchNodes/Helpers/ISearchNodesState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";

export function WorkflowNodeDeleteDropTarget({
    node,
}: {
    node: IWorkflowNode;
}) {
    const dropTargetResult = useDropTarget<IWorkflowNode>(
        [EDragDropObject.workflowNode],
        HandleDroppedWorkflowNodeAsync
    );

    if (
        !dropTargetResult.isDragging ||
        dropTargetResult.draggedObject.id !== node.id
    ) {
        return null;
    }

    const elementToDisplay = dropTargetResult.isOver ? (
        <span style={{ fontWeight: `bold` }}>delete node</span>
    ) : (
        <span>drop to delete</span>
    );

    return (
        <span ref={dropTargetResult.dropTargetRef}>
            <span style={{ margin: `0.6em` }}>
                <Glyphicon icon={EGlyphicon.trash} />
            </span>
            {elementToDisplay}
        </span>
    );
}

async function HandleDroppedWorkflowNodeAsync(node: IWorkflowNode) {
    const searchNodes = State.ReadClass<ISearchNodesState>(
        ESharedComponent.SearchNodes
    );

    try {
        await WithAnimatedProgressBarAsync(async () => {
            searchNodes.setState({ showLoadingIndicator: true });
            await DeleteNodeAsync(node);
        });
    } finally {
        searchNodes.setState({ showLoadingIndicator: false });
    }
}
